<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row v-if="authPermissions.has('lost:create')">
          <v-col lg="2" cols="12">
            <import-lost-inventories />
          </v-col>
          <v-col lg="2" cols="12">
            <export-lost-inventories />
          </v-col>
        </v-row>
        <v-expansion-panels v-if="authPermissions.has('lost:view')">
          <v-expansion-panel>
            <v-expansion-panel-header color="primary" dark class="white--text p-0">
              <template v-slot:actions>
                <v-icon class="icon white--text">$expand</v-icon>
              </template>
              Lost Products
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <index-lost-inventories @edit="initEditLostInventories" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" v-if="authPermissions.has('lost:create')">
        <create-lost-inventories />
      </v-col>
    </v-row>
    <v-dialog dismissable max-width="600px" v-model="editLostInventories" eager class="pa-0">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title class="pa-0">Edit Lost Product</v-card-title>
        </v-toolbar>
        <edit-lost-inventories ref="edit-lost-inventories"
          @close-dialog="editLostInventories = false"></edit-lost-inventories>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'vLostInventories',
  data() {
    return {
      editLostInventories: false,
    }
  },
  components: {
    createLostInventories: () => import('./../components/lost-inventories/Create'),
    indexLostInventories: () => import('./../components/lost-inventories/Index'),
    editLostInventories: () => import('./../components/lost-inventories/Edit'),
    importLostInventories: () => import('./../components/lost-inventories/Import'),
    exportLostInventories: () => import('./../components/lost-inventories/Export'),
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditLostInventories(data) {
      const { populateInputs } = this.$refs['edit-lost-inventories']
      populateInputs(data)
      this.editLostInventories = true
    },
  },
}
</script>
